@if (!loadingData) {
  <question-description
    titleDir="left"
    subTitleDir="left"
    title="Quelle est la nature de votre {{
      chooseOperation === 'SUBSCRIPTION' ? 'souscription' : 'opération'
    }} ?"
  >
  </question-description>
  <form (ngSubmit)="onSubmit()" [formGroup]="form" class="form">
    <div class="row">
      <div class="col col-md-12">
        <pr-input-autosuggest
          data-testid="dashboard-souscription-init-product-input"
          formControlName="product"
          label="Choix du produit {{
            chooseOperation === 'TRANSFER' ? 'de réception' : ''
          }}"
          [options]="products"
          [derrors]="derrors"
          [optionLabel]="'name'"
          [additionalOptionLabel]="
            ['UNFURNISHED', 'LMNP'].includes(productType)
              ? additionalOptionLabel
              : []
          "
          [objectMapper]="objectMapper"
          [isDefault]="false"
          [optionIcon]="getIcon"
          [noCustom]="true"
        >
        </pr-input-autosuggest>
      </div>
    </div>
    @if (
      form.get('product')?.value &&
      isUnfurnishedOrLMP_LMNP() &&
      isGridky(form.get('product')?.value)
    ) {
      @if (gridky$ | async; as gridkyOptions) {
        <div class="row">
          <div class="col col-md-12">
            <pr-input-column label="Lot" [derrors]="derrors">
              <mat-select
                (valueChange)="onSelect($event)"
                formControlName="gridkyPropertyId"
              >
                @for (option of gridkyOptions; track option) {
                  <mat-option [value]="option.id">
                    {{ typeMapper?.[option?.type] || option?.type }} -
                    {{ option?.typology }} - {{ option?.surface }} m² -
                    {{ option?.priceInclTax }} €
                  </mat-option>
                }
              </mat-select>
            </pr-input-column>
          </div>
        </div>
      } @else {
        <ng-template [ngTemplateOutlet]="loadingTem"></ng-template>
      }
    }
    @if (form.get('product')?.value && isBorrowerInsurance()) {
      @if (loans$ | async; as loansOptions) {
        <div class="row">
          <div class="col col-md-12">
            <pr-input-column label="Crédit" [derrors]="derrors">
              <mat-select formControlName="loanId">
                <mat-option value="AUTRE">Nouveau prêt</mat-option>
                @for (option of loansOptions; track option) {
                  <mat-option [value]="option.id">
                    {{ getLoanCategoryName(option.category) }} -
                    {{ option.label }}
                  </mat-option>
                }
              </mat-select>
            </pr-input-column>
          </div>
          <div class="col col-md-12">
            <pr-input-column label="Contexte" [derrors]="derrors">
              <mat-select formControlName="borrowerInsuranceContext">
                <mat-option value="NEW"
                  >Nouvelle assurance emprunteur</mat-option
                >
                <mat-option value="CHANGE"
                  >Changement assurance emprunteur</mat-option
                >
              </mat-select>
            </pr-input-column>
          </div>
          <div class="col col-md-12">
            <pr-input-column label="Mode" [derrors]="derrors">
              <mat-select formControlName="borrowerInsuranceMode">
                <mat-option value="MANUAL">Manuel - Dérogatoire</mat-option>
                @if (form.get('allowedApiFlux')?.value) {
                  <mat-option value="API">API - Standard</mat-option>
                }
              </mat-select>
            </pr-input-column>
          </div>
        </div>
      } @else {
        <ng-template [ngTemplateOutlet]="loadingTem"></ng-template>
      }
    }
    <info [option]="{ icon: 'info' }">
      Dans le cadre de nos obligations liées au RGPD, nous ne vendrons jamais
      vos données personnelles collectées dans le cadre de notre relation et de
      notre activité de conseil. Vos données seront uniquement transmises aux
      partenaires des produits investis afin de réaliser votre souscription.
      Elles seront également utilisées au sein de l’application Albr.
    </info>
    <form-footer (prev)="prev()" (next)="onSubmit()"></form-footer>
  </form>
}
@if (loadingData) {
  <pr-loader text="Chargement en cours…"></pr-loader>
}
